import React, {useEffect, useState} from 'react';
import {Button, Form} from "semantic-ui-react";
import {toast} from "react-toastify";
import {apiGet} from "../../../services/apiClient";
import Dropdown from "../../../components/Dropdown";

const SetCompanyBlock = ({onChange, companyId}) => {
    const errorText = 'Пожалуйста, заполните поле "Юр. лицо клиента"';
    const [id, setId] = useState(companyId);
    const [options, setOptions] = useState([]);
    const onClick = () => {
        id ? onChange(id) : toast.error(errorText);
    }

    const loadData = () => {
        return apiGet('parcels/ref/companies/list').then(data => {
            setOptions((data.entries || []).map(i => ({
                key: i.id,
                value: i.id,
                text: i.name,
            })));
        })
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div className='company-block'>
            <Form.Field>
                <label>
                    Юридическое лицо клиента*
                </label>
                <Dropdown
                    value={id}
                    onChange={(e, {value}) => setId(value)}
                    selection
                    search
                    options={options}
                    selectOnBlur={false}
                />
            </Form.Field>
            <div className='step-btn-block'>
                <Button className='step-btn-block__btn' color={'blue'} onClick={onClick}>
                    Далее
                </Button>
            </div>
        </div>
    );
};

export default SetCompanyBlock;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/setCompanyBlock.jsx